define.alias("ember-basic-dropdown/components/basic-dropdown", "calendar/components/basic-dropdown");